import { render } from "./LbrxStatisticsBox.vue?vue&type=template&id=11b7bbe5&scoped=true"
import script from "./LbrxStatisticsBox.vue?vue&type=script&lang=js"
export * from "./LbrxStatisticsBox.vue?vue&type=script&lang=js"

import "./LbrxStatisticsBox.vue?vue&type=style&index=0&id=11b7bbe5&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b7bbe5"]])

export default __exports__